module.exports = __webpack_public_path__ + "img/infographicWhoWeAreHorizontal.cae1aec0.png";